import React from 'react';

import { QuestionFileComponentDefaultProps, QuestionFileComponentPropTypes } from 'src/components/JobDatasheet/propTypes';
import Attachments from 'src/components/Attachments';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

const checkCompatibility = (value, selectedValue) => {
  if (value && Array.isArray(value[selectedValue])) {
    return value[selectedValue];
  }
  return value
    ? [value[selectedValue]].filter(el => {
      return el != null;
    })
    : [];
};

const QuestionFileComponent = ({
  isRectifiedQuestion,
  onChange,
  question,
  readonly,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';

  const getReturnObject = (val => {
    const returnObject = {
      ...value,
      type: 'file'
    };

    returnObject[selectedValueKey] = val;

    return returnObject;
  });

  const propFiles = checkCompatibility(value, selectedValueKey);
  const attachmentsToArray = filePath => {
    propFiles.push(filePath);
    return onChange(getReturnObject(propFiles));
  };
  const filterDeletedFiles = (name, attId) => [...propFiles]
    .filter(file => name !== file.name || attId !== file.attId);

  return (
    <s.FileWrapper downloadonly={!!readonly}>
      <Attachments
        key={JSON.stringify(question)}
        attachmentIds={propFiles}
        disabled={!!readonly}
        entity="job_attachment"
        onChange={!disableChange && ((_filename, _entity, _id, meta) => attachmentsToArray(meta)) }
        onDeleteFile={(name, attId) => onChange(
          getReturnObject(filterDeletedFiles(name, attId))
        )}
      />
    </s.FileWrapper>
  );
};

QuestionFileComponent.propTypes = QuestionFileComponentPropTypes;
QuestionFileComponent.defaultProps = QuestionFileComponentDefaultProps;

export const QuestionFile = React.memo(QuestionFileComponent);
